import React from 'react'
import { useTranslation } from 'react-i18next'
import './DsmpChart.scss'

type Props = {
  dsmpQ1?: number
  dsmpQ2?: number
}

export function DsmpChart({ dsmpQ1, dsmpQ2 }: Props) {
  const { t } = useTranslation('DsmpResult')
  const format = (value?: number) =>
    value != null ? new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 }).format(value) : '—'

  return (
    <div className="DsmpChart" role="img" aria-label={t('chartAria')}>
      <div className="DsmpChart-bar DsmpChart-bar--q1">
        <span className="DsmpChart-label">{t('q1')}</span>
        <span className="DsmpChart-value">{format(dsmpQ1)}</span>
      </div>
      {dsmpQ2 != null && (
        <div className="DsmpChart-bar DsmpChart-bar--q2">
          <span className="DsmpChart-label">{t('q2')}</span>
          <span className="DsmpChart-value">{format(dsmpQ2)}</span>
        </div>
      )}
    </div>
  )
}

export default DsmpChart
